var map = {
	"./404.svg": 34441,
	"./bug.svg": 53795,
	"./chart.svg": 24245,
	"./clipboard.svg": 49511,
	"./component.svg": 25932,
	"./dashboard.svg": 80677,
	"./documentation.svg": 53551,
	"./drag.svg": 13501,
	"./edit.svg": 11007,
	"./education.svg": 13043,
	"./email.svg": 84353,
	"./example.svg": 99071,
	"./excel.svg": 41292,
	"./exit-fullscreen.svg": 34743,
	"./eye-open.svg": 26751,
	"./eye.svg": 96394,
	"./form.svg": 16601,
	"./full-screen.svg": 50081,
	"./fullscreen.svg": 48140,
	"./guide.svg": 88829,
	"./icon.svg": 74684,
	"./international.svg": 27397,
	"./language.svg": 57909,
	"./link.svg": 95519,
	"./list.svg": 58711,
	"./lock.svg": 47002,
	"./message.svg": 77928,
	"./money.svg": 13121,
	"./nested.svg": 19514,
	"./off-screen.svg": 50351,
	"./password.svg": 30892,
	"./pdf.svg": 73923,
	"./people.svg": 92006,
	"./peoples.svg": 98233,
	"./qq.svg": 4065,
	"./refresh.svg": 1248,
	"./search.svg": 76455,
	"./shopping.svg": 84987,
	"./size.svg": 19456,
	"./skill.svg": 87974,
	"./star.svg": 92319,
	"./tab.svg": 23912,
	"./table.svg": 95177,
	"./theme.svg": 15234,
	"./tree-table.svg": 26368,
	"./tree.svg": 21443,
	"./user.svg": 64218,
	"./wechat.svg": 7513,
	"./zip.svg": 17608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;